import ObjectCreate from './ObjectCreate';

export default ObjectCreate;
